/**
 * This represents some generic auth provider API, like Firebase.
 */
const carebeeAuthProvider = {
  isAuthenticated: false,
  signin(callback: VoidFunction) {
    this.isAuthenticated = true;
    setTimeout(callback, 100); // fake async
  },
  signout(callback: VoidFunction) {
    this.isAuthenticated = false;
    setTimeout(callback, 100);
  }
};

export default carebeeAuthProvider;
